"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var ListItem_1 = __importDefault(require("./ListItem"));

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(ListItem_1.default, 'base', 'list', ['multipartListItem']);